import { Routes } from "@angular/router";
import { AuthGuardService } from "./core/guards/auth-guard.service";

export const routes: Routes = [
    {
    path: 'login',
    loadChildren: () =>
      import("./modules/public/login/login.routes").then(
        (m) => m.LOGIN_ROUTES,
      ),
    
  },
    {
    path: 'registration',
    loadChildren: () =>
      import("./modules/public/registration/registration.routes").then(
        (m) => m.REGISTRATION_ROUTES,
      ),
    
  },
    {
    path: 'dashboard',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./modules/private/layout/layout.route").then(
        (m) => m.HOME_ROUTES,
      ),
    
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];
